(function () {
  function applyMakeLogos(root) {
    const registry = document.getElementById('menu-make-logos');
    if (!registry) return;

    const logos = new Map();
    registry.querySelectorAll('[data-make-logo]').forEach((entry) => {
      const title = entry.dataset.title?.trim().toLowerCase();
      if (!title || !entry.dataset.src) return;
      logos.set(title, {
        src: entry.dataset.src,
        alt: entry.dataset.alt || title,
        width: entry.dataset.width,
        height: entry.dataset.height,
      });
    });

    root.querySelectorAll('[data-make-logo-slot]').forEach((slot) => {
      const title = slot.dataset.makeLogoTitle?.trim().toLowerCase();
      const logo = title ? logos.get(title) : null;
      if (!logo) return;

      const img = document.createElement('img');
      img.src = logo.src;
      img.alt = logo.alt;
      img.className = 'mega-menu-tiered__make-logo';
      img.width = Number(logo.width) || 40;
      img.height = Number(logo.height) || 40;
      img.loading = 'lazy';
      slot.replaceWith(img);
    });
  }

  function hydrateDeferredPanels(root) {
    if (!root || root.dataset.panelsHydrated === 'true') return;
    const template = root.querySelector(':scope > template[data-deferred-panels]');
    if (template) {
      root.appendChild(template.content.cloneNode(true));
      template.remove();
    }
    root.dataset.panelsHydrated = 'true';
  }

  function resetMobileTieredCar(root) {
    if (!root) return;
    const panels = Array.from(root.querySelectorAll('[data-mobile-tiered-panel]'));
    panels.forEach((panel) => {
      const isMakes = panel.dataset.mobileTieredPanel === 'makes';
      panel.classList.toggle('is-active', isMakes);
      panel.toggleAttribute('hidden', !isMakes);
    });
    const scrollHost = root.closest('.simple-menu-content') || root.parentElement;
    if (scrollHost) scrollHost.scrollTop = 0;
  }

  function initMobileTieredCar(root) {
    if (!root || root.dataset.mobileTieredInitialized === 'true') return;
    root.dataset.mobileTieredInitialized = 'true';

    const drawer = document.getElementById('Drawer-Menu');
    if (!drawer || drawer.classList.contains('active')) {
      applyMakeLogos(root);
    } else {
      const logoObserver = new MutationObserver(() => {
        if (!drawer.classList.contains('active')) return;
        logoObserver.disconnect();
        applyMakeLogos(root);
      });
      logoObserver.observe(drawer, { attributes: true, attributeFilter: ['class'] });
    }

    let panels = Array.from(root.querySelectorAll('[data-mobile-tiered-panel]'));

    function refreshPanels() {
      hydrateDeferredPanels(root);
      applyMakeLogos(root);
      panels = Array.from(root.querySelectorAll('[data-mobile-tiered-panel]'));
    }

    function showPanel(panelName, makeIndex, seriesIndex) {
      if (panelName !== 'makes') refreshPanels();
      panels.forEach((panel) => {
        const isMakes = panel.dataset.mobileTieredPanel === 'makes';
        const isSeries =
          panel.dataset.mobileTieredPanel === 'series' &&
          panel.dataset.makeIndex === String(makeIndex);
        const isModels =
          panel.dataset.mobileTieredPanel === 'models' &&
          panel.dataset.makeIndex === String(makeIndex) &&
          panel.dataset.seriesIndex === String(seriesIndex);

        const isActive = isMakes
          ? panelName === 'makes'
          : isSeries
            ? panelName === 'series'
            : isModels
              ? panelName === 'models'
              : false;

        panel.classList.toggle('is-active', isActive);
        panel.toggleAttribute('hidden', !isActive);
      });

      const scrollHost = root.closest('.simple-menu-content') || root.parentElement;
      if (scrollHost) scrollHost.scrollTop = 0;
    }

    root.addEventListener('click', (event) => {
      const openSeries = event.target.closest('[data-mobile-tiered-open-series]');
      if (openSeries && root.contains(openSeries)) {
        event.preventDefault();
        showPanel('series', openSeries.dataset.makeIndex);
        return;
      }

      const openModels = event.target.closest('[data-mobile-tiered-open-models]');
      if (openModels && root.contains(openModels)) {
        event.preventDefault();
        showPanel('models', openModels.dataset.makeIndex, openModels.dataset.seriesIndex);
        return;
      }

      const back = event.target.closest('[data-mobile-tiered-back]');
      if (back && root.contains(back)) {
        event.preventDefault();
        const target = back.dataset.mobileTieredBack;
        if (target === 'makes') {
          showPanel('makes');
        } else if (target === 'series') {
          showPanel('series', back.dataset.makeIndex);
        }
      }
    });
  }

  function initAll() {
    document.querySelectorAll('[data-mobile-tiered-car]').forEach(initMobileTieredCar);
  }

  function resetAll() {
    document.querySelectorAll('[data-mobile-tiered-car]').forEach(resetMobileTieredCar);
  }

  window.resetMobileTieredCarMenus = resetAll;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', initAll);
})();
